import React from 'react'

export const Bus = ({ fill }) => (
<svg width="56.6929px" height="34.1174px" viewBox="0 0 56.6929 34.1174">
<g fill={fill}>
<g>
	<g>
		<path class="st0" d="M47.9929,31.2891h-6.6523c-0.3037,0-0.5498-0.2461-0.5498-0.5498s0.2461-0.5498,0.5498-0.5498h6.6523
			c0.3877,0,0.7041-0.3164,0.7041-0.7041V22.585c0-4.373-1.5684-7.7949-2.5029-9.4453c-0.2803-0.2861-2.3252-0.668-3.1553-0.668
			H6.4743c-0.7344,0-1.332,0.5977-1.332,1.332v15.6816c0,0.3877,0.3164,0.7041,0.7051,0.7041h4.6519
			c0.3037,0,0.5498,0.2461,0.5498,0.5498s-0.2461,0.5498-0.5498,0.5498H5.8473c-0.9951,0-1.8047-0.8086-1.8047-1.8037V13.8038
			c0-1.3408,1.0908-2.4316,2.4316-2.4316h36.5645c0.0342,0,3.5244,0.1875,4.1123,1.2246c0.9883,1.7451,2.6455,5.3633,2.6455,9.9883
			v6.9004C49.7966,30.4805,48.988,31.2891,47.9929,31.2891z"/>
	</g>
	<g>
		<path class="st0" d="M35.5895,31.2891H16.2497c-0.3037,0-0.5498-0.2461-0.5498-0.5498s0.2461-0.5498,0.5498-0.5498h19.3398
			c0.3037,0,0.5498,0.2461,0.5498,0.5498S35.8932,31.2891,35.5895,31.2891z"/>
	</g>
	<g>
		<path class="st0" d="M47.1657,14.3536H4.5925c-0.3037,0-0.5498-0.2461-0.5498-0.5498s0.2461-0.5498,0.5498-0.5498h42.5732
			c0.3037,0,0.5498,0.2461,0.5498,0.5498S47.4694,14.3536,47.1657,14.3536z"/>
	</g>
	<g>
		<path class="st0" d="M49.2468,26.2715H46.111c-0.1113,0-0.2188-0.0332-0.3105-0.0957l-6.2764-4.2949H4.5925
			c-0.3037,0-0.5498-0.2461-0.5498-0.5498s0.2461-0.5498,0.5498-0.5498H39.694c0.1113,0,0.2188,0.0332,0.3105,0.0957l6.2764,4.2949
			h2.9658c0.3037,0,0.5498,0.2461,0.5498,0.5498S49.5505,26.2715,49.2468,26.2715z"/>
	</g>
	<g>
		<path class="st0" d="M38.4655,33.171c-2.0332,0-3.6865-1.6533-3.6865-3.6855c0-2.0332,1.6533-3.6865,3.6865-3.6865
			c2.0322,0,3.6855,1.6533,3.6855,3.6865C42.1511,31.5176,40.4977,33.171,38.4655,33.171z M38.4655,26.8985
			c-1.4268,0-2.5869,1.1602-2.5869,2.5869c0,1.4258,1.1602,2.5859,2.5869,2.5859c1.4258,0,2.5859-1.1602,2.5859-2.5859
			C41.0514,28.0586,39.8913,26.8985,38.4655,26.8985z"/>
	</g>
	<g>
		<path class="st0" d="M13.3742,33.171c-2.0327,0-3.686-1.6533-3.686-3.6855c0-2.0332,1.6533-3.6865,3.686-3.6865
			s3.6865,1.6533,3.6865,3.6865C17.0607,31.5176,15.4069,33.171,13.3742,33.171z M13.3742,26.8985
			c-1.4263,0-2.5864,1.1602-2.5864,2.5869c0,1.4258,1.1602,2.5859,2.5864,2.5859s2.5869-1.1602,2.5869-2.5859
			C15.9611,28.0586,14.8005,26.8985,13.3742,26.8985z"/>
	</g>
	<g>
		<path class="st0" d="M49.2468,28.7803h-1.2539c-0.3037,0-0.5498-0.2461-0.5498-0.5498s0.2461-0.5498,0.5498-0.5498h1.2539
			c0.3037,0,0.5498,0.2461,0.5498,0.5498S49.5505,28.7803,49.2468,28.7803z"/>
	</g>
	<g>
		<path class="st0" d="M5.8073,27.5254H4.5925c-0.3037,0-0.5498-0.2461-0.5498-0.5498s0.2461-0.5498,0.5498-0.5498h1.2148
			c0.3037,0,0.5498,0.2461,0.5498,0.5498S6.111,27.5254,5.8073,27.5254z"/>
	</g>
	<g>
		<path class="st0" d="M5.8073,25.0167H4.5925c-0.3037,0-0.5498-0.2461-0.5498-0.5498s0.2461-0.5498,0.5498-0.5498h1.2148
			c0.3037,0,0.5498,0.2461,0.5498,0.5498S6.111,25.0167,5.8073,25.0167z"/>
	</g>
	<g>
		<path class="st0" d="M39.7194,21.8809c-0.3037,0-0.5498-0.2461-0.5498-0.5498v-7.5273c0-0.3037,0.2461-0.5498,0.5498-0.5498
			s0.5498,0.2461,0.5498,0.5498v7.5273C40.2692,21.6348,40.0231,21.8809,39.7194,21.8809z"/>
	</g>
	<g>
		<path class="st0" d="M32.1921,21.8809c-0.3037,0-0.5498-0.2461-0.5498-0.5498v-7.5273c0-0.3037,0.2461-0.5498,0.5498-0.5498
			c0.3037,0,0.5498,0.2461,0.5498,0.5498v7.5273C32.7419,21.6348,32.4958,21.8809,32.1921,21.8809z"/>
	</g>
	<g>
		<path class="st0" d="M24.6652,21.8809c-0.3037,0-0.5498-0.2461-0.5498-0.5498v-7.5273c0-0.3037,0.2461-0.5498,0.5498-0.5498
			s0.5498,0.2461,0.5498,0.5498v7.5273C25.215,21.6348,24.9689,21.8809,24.6652,21.8809z"/>
	</g>
	<g>
		<path class="st0" d="M17.1379,21.8809c-0.3037,0-0.5498-0.2461-0.5498-0.5498v-7.5273c0-0.3037,0.2461-0.5498,0.5498-0.5498
			s0.5498,0.2461,0.5498,0.5498v7.5273C17.6877,21.6348,17.4416,21.8809,17.1379,21.8809z"/>
	</g>
	<g>
		<path class="st0" d="M9.611,21.8809c-0.3037,0-0.5498-0.2461-0.5498-0.5498v-7.5273c0-0.3037,0.2461-0.5498,0.5498-0.5498
			s0.5498,0.2461,0.5498,0.5498v7.5273C10.1608,21.6348,9.9147,21.8809,9.611,21.8809z"/>
	</g>
</g>
<g>
	<path class="st0" d="M50.6032,15.8887c-0.0654,0-0.1318-0.0117-0.1963-0.0361c-1.2861-0.4922-3.3906-1.2939-3.5674-1.3506
		c-0.2998-0.0527-0.4707-0.3311-0.418-0.6299c0.0518-0.2988,0.3574-0.4932,0.666-0.4404c0.0664,0.0117,0.1357,0.0244,3.7119,1.3936
		c0.2842,0.1084,0.4258,0.4268,0.3174,0.71C51.0329,15.7549,50.8239,15.8887,50.6032,15.8887z"/>
</g>
<g>
	<path class="st0" d="M51.3825,21.71c-0.0928,0-0.1846-0.0234-0.2676-0.0693c-0.1367-0.0762-0.2344-0.207-0.2686-0.3594
		L49.57,15.6329c-0.0625-0.2725,0.0908-0.5488,0.3555-0.6406l0.4971-0.1729c1.1963-0.2725,2.332,0.4434,2.5898,1.5801l0.5859,2.5947
		c0.2568,1.1377-0.46,2.2725-1.5967,2.5303l-0.4395,0.1553C51.5036,21.7003,51.443,21.71,51.3825,21.71z M50.7507,15.8702
		l1.0342,4.5752c0.5518-0.1699,0.8584-0.6885,0.7412-1.209l-0.5859-2.5938C51.818,16.1055,51.2868,15.7608,50.7507,15.8702z"/>
</g>
</g>
</svg>
)

